<template>
  <div class="registrationDetails">
    <div class="registrationDetailsContainer">
      <div class="registrationTip" :style="{ background: $route.query.isPaymentSuccess == 1 ? '#17c79f' : '#989898' }">
        <div class="title">
          <template v-if="$route.query.isPaymentSuccess == 1">
            <img src="@/assets/icons/success.png" alt="Success" />
            <span>挂号成功</span>
          </template>
          <template v-else>
            <img src="@/assets/icons/pendingOrCancel.png" alt="Success" />
            <span>待缴费</span>
          </template>
        </div>
        <div class="tips">
          请您提前30分钟到指示诊室签到取号后候诊。听到叫您的名字时，请及时进诊看医生。距离就诊时间剩30分钟，将关闭退款通道。如果错过时间，本次挂号作废，需重新挂号排队。
        </div>
      </div>
      <!-- 就诊凭条 -->
      <div class="barCodeContainer">
        <h3>就诊凭条</h3>
        <svg id="barCode"></svg>
      </div>
      <!-- 就诊信息 -->
      <div class="appointmentInfo">
        <h3>就诊信息</h3>
        <div class="infoRow">
          <span>就诊人</span>
          <span>{{ registerData.patientName }}</span>
        </div>
        <div class="infoRow">
          <span>就诊卡号</span>
          <span>{{ registerData.userMedicalCard }}</span>
        </div>
        <div class="infoRow">
          <span>科室位置</span>
          <span></span>
        </div>
        <div class="infoRow">
          <span>就诊时段</span>
          <span>
            {{ registerData.visitDate.date }} {{ registerData.visitDate.day.replace('周', '星期') }} {{ registerData.startTime.slice(0, 5) }}~{{
              (registerData.stopTime || registerData.endTime).slice(0, 5)
            }}
          </span>
        </div>
        <div class="infoRow">
          <span>医院名称</span>
          <span>{{ registerData.hospitalName }}</span>
        </div>
        <div class="infoRow">
          <span>就诊科室</span>
          <span>{{ registerData.departName }}</span>
        </div>
        <div class="infoRow">
          <span>医生姓名</span>
          <span>{{ registerData.doctorName }}</span>
        </div>
        <div class="infoRow">
          <span>医生职称</span>
          <span>{{ registerData.clinicType }}</span>
        </div>
      </div>
      <!-- 缴费详情 -->
      <div class="paymentDetails">
        <h3 @click="isShowPaymentDetails = !isShowPaymentDetails">缴费详情</h3>
        <template v-if="isShowPaymentDetails">
          <div class="infoRow">
            <span>医院名称</span>
            <span>{{ registerData.hospitalName }}</span>
          </div>
          <div class="infoRow">
            <span>医院单号</span>
            <span></span>
          </div>
          <div class="infoRow">
            <span>流水单号</span>
            <span>{{ registerData.registrationTradeNo }}</span>
          </div>
          <div class="infoRow">
            <span>挂号费用</span>
            <span>¥{{ registerData.regFee }}</span>
          </div>
          <div class="infoRow">
            <span>状态值</span>
            <span>已缴费</span>
          </div>
          <div class="infoRow">
            <span>就诊状态</span>
            <span>未报到</span>
          </div>
        </template>
        <div class="arrowContainer" @click="isShowPaymentDetails = !isShowPaymentDetails">
          <img v-if="isShowPaymentDetails" src="@/assets/icons/topArrow.png" alt="" />
          <img v-else src="@/assets/icons/downArrow.png" alt="" />
        </div>
      </div>
    </div>
    <div class="cancelButtonContainer" v-if="false">
      <van-button type="default" size="large">取消挂号</van-button>
    </div>
  </div>
</template>

<script>
import JsBarcode from 'jsbarcode';

export default {
  data() {
    return {
      isShowPaymentDetails: false,
      registerData: null // 挂号详情数据
    };
  },
  // watch: {
  //   '$store.state.registerData': {
  //     handler(val) {
  //       console.log(val);

  //       this.doctorInfo = val;
  //     },
  //     deep: true,
  //     immediate: true
  //   }
  // },
  created() {
    this.registerData = this.$store.state.registerData || {};
    console.log(this.registerData);
  },
  mounted() {
    this.renderBarcode();
  },
  methods: {
    renderBarcode() {
      const codeText = !!this.registerData.userMedicalCard ? this.registerData.userMedicalCard : '';
      this.$nextTick(() => {
        const barcodeElement = document.getElementById('barCode');
        if (barcodeElement) {
          JsBarcode(barcodeElement, codeText, {
            format: 'CODE128',
            lineColor: '#000',
            width: 3,
            height: 60,
            margin: 5,
            fontSize: 20,
            displayValue: true
          });
        } else {
          console.error('条形码元素未找到');
        }
      });
    },
    cancelRegistration() {
      // 实现取消挂号的逻辑
    }
  }
};
</script>

<style lang="scss" scoped>
.registrationDetails {
  width: 100vw;
  height: 100vh;
  background: #f9f9f9;
  box-sizing: border-box;

  font-family: Source Han Sans SC, Source Han Sans SC;
  .registrationDetailsContainer {
    overflow: hidden;
    overflow-y: auto;
    height: 89.5vh;
    .registrationTip {
      width: 100%;
      padding: 2.7vw;
      background: #17c79f;
      color: #fff;
      box-sizing: border-box;

      .title {
        display: flex;
        align-items: center;
        img {
          width: 8vw;
          height: 8vw;
          margin-right: 1.6vw;
        }
        span {
          font-size: 6.4vw;
        }
      }
      .tips {
        margin-top: 2.1vh;
        font-size: 3.7vw;
        line-height: 1.5;
      }
    }

    .barCodeContainer {
      text-align: center;
      background: #fff;
      #barCode {
        display: inline-block;
      }
      h3 {
        text-align: left;
        padding-left: 2.7vw;
        padding-top: 2.7vh;
        padding-bottom: 1.8vh;
        font-size: 4.8vw;
      }
    }

    .appointmentInfo,
    .paymentDetails {
      background: #fff;
      margin-top: 0.6vh;
      padding: 2vh 2.7vw;
      box-sizing: border-box;

      h3 {
        margin: 0;
        margin-bottom: 1.2vh;
        font-size: 4.8vw;
        color: #333;
      }
      .infoRow {
        display: flex;
        justify-content: space-between;
        padding-top: 2.6vh;
        span {
          font-size: 4.3vw;
          color: #666;
        }
        &:last-child {
          border-bottom: none;
        }
      }
    }
    .paymentDetails {
      position: relative;
      .arrowContainer {
        position: absolute;
        top: 2.6vh;
        right: 2.7vw;
        img {
          width: 6.9vw;
          height: 6.9vw;
        }
      }
    }
  }

  .cancelButtonContainer {
    text-align: center;
    padding: 2.6vh 7.5vw;
    box-sizing: border-box;
    button {
      border: none;
      border-radius: 2.1vw;
      cursor: pointer;
      font-size: 5.9vw;
    }
  }
}
</style>
